import React from 'react';
import { Svg, ISvg } from '../Svg';

export const HardestRound: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 1440 85" preserveAspectRatio="none" fill="none" {...props}>
    <path
      d="M0 83C454.33-24.774 928.696-27.898 1384.99 71.96L1440 83v2H0Z"
      fill="#ffffff"
    />
  </Svg>
);
